import { render, staticRenderFns } from "./IconRequests.vue?vue&type=template&id=ac4f3962&functional=true"
import script from "./IconRequests.vue?vue&type=script&lang=js"
export * from "./IconRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports